import { Amex, Bank, Mastercard, Visa } from '@shared/icons';
import type { IconSize } from '@shared/icons/types';

type PaymentInstrumentIconProps = {
  type: string | undefined;
  size?: IconSize;
};

/**
 * Single source of truth for mapping a payment-instrument type to its brand icon.
 *
 * @param type - The card brand to display the icon for.
 * @param size - The size of the icon to display.
 * @returns The icon for the given card brand.
 */
function PaymentInstrumentIcon({ type, size = 'medium' }: PaymentInstrumentIconProps) {
  const normalisedType = (type ?? '').toUpperCase();
  if (normalisedType.startsWith('VISA')) return <Visa size={size} />;
  if (normalisedType.startsWith('MASTERCARD')) return <Mastercard size={size} />;
  if (normalisedType.startsWith('AMEX')) return <Amex size={size} />;
  return <Bank size={size} />;
}

export { PaymentInstrumentIcon };
export type { PaymentInstrumentIconProps };
